import React, { useEffect, useState } from "react";
import {
  Content,
  Col,
  Box,
  Button,
  Pagination,
  SimpleTable,
} from "adminlte-2-react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import _ from "lodash";
import controller from "../reservas/duck";
import { useSelector, useDispatch } from "react-redux";
import LoaderCalendario from "../utils/LoaderCalendario";
import { parseJwt } from "../utils/utils";
require("moment/locale/es.js");

const localizer = momentLocalizer(moment);

function ReservaDetalle({ history, match }) {
  const dispatch = useDispatch();

  const [reserva, setReserva] = useState(null);
  const [reservasALaPar, setReservasALaPar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fecha, setFecha] = useState(null);
  const [desde, setDesde] = useState(null);
  const [hasta, setHasta] = useState(null);
  const [actualRol, setActualRol] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [list, setList] = useState([]);

  const sumarMinutos = (horaIncial, suma) => {
    const hora = moment(horaIncial, "YYYY-MM-DD HH:mm")
      .add(suma, "minutes")
      .format("YYYY-MM-DD HH:mm");
    return hora;
  };

  const modelEventos = useSelector((state) => state.reservasConfirmadasByLocal);
  const modelReservasALaPar = useSelector((state) => state.reservasALaPar);
  const modelCancelar = useSelector((state) => state.cancelarReserva);

  // mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return history.push("/logout");
    }
    const decodedToken = parseJwt(token);

    setActualRol(decodedToken.rol);
    dispatch(
      controller.getReservasByLocalThunk(
        match.params.reservaId,
        null,
        null,
        null
      )
    );
  }, []);

  useEffect(() => {
    const data = modelEventos?.data?.data;
    const error = modelEventos?.error?.response?.data?.mensaje;

    if (error) {
      setLoading(false);
      alert(error);
      dispatch(controller.reservasConfirmadasByLocalDuck.actions.clear());
    }
    if (data) {
      const reserva = { ...data.data[0], plataforma: "ADMIN" };

      setReserva(reserva);
      console.log("Datos de reserva: ", reserva);

      const final = reserva.duracion
        ? sumarMinutos(moment(reserva.fecha), reserva.duracion)
        : reserva.fecha;
      setFecha(moment(reserva.fecha).utc().format("YYYY-MM-DD"));
      setDesde(moment(reserva.fecha).utc().format("YYYY-MM-DD HH:mm"));
      setHasta(moment(final).utc().format("YYYY-MM-DD HH:mm"));

      dispatch(controller.reservasConfirmadasByLocalDuck.actions.clear());
      dispatch(
        controller.getReservasALaParThunk(
          match.params.reservaId,
          reserva.detalles.horarioId,
          reserva.detalles.localId
        )
      );
    }
  }, [modelEventos]);

  useEffect(() => {
    const data = modelReservasALaPar?.data?.data;
    const error = modelReservasALaPar?.error?.response?.data?.mensaje;

    if (error) {
      setLoading(false);
      alert(error);
      dispatch(controller.reservasALaParDuck.actions.clear());
    }
    if (data) {
      setList(data.data.items);
      setTotalResults(data.data.total);
      dispatch(controller.reservasALaParDuck.actions.clear());

      setLoading(false);
    }
  }, [modelReservasALaPar]);

  useEffect(() => {
    const data = modelCancelar?.data?.data;
    const error = modelCancelar?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.cancelarReservaDuck.actions.clear());
    }
    if (data) {
      dispatch(controller.cancelarReservaDuck.actions.clear());
      history.goBack();
    }
  }, [modelCancelar]);

  const cancelarReserva = () => {
    var answer = window.confirm(
      "¿Esta seguro que desea cancelar esta reserva?"
    );
    if (answer) {
      setLoading(true);
      dispatch(controller.cancelarReservaThunk(reserva));
    }
  };

  function handlePage(page) {
    setActivePage(page);
    setReservasALaPar([]);
    dispatch(
      controller.getReservasALaParThunk(
        match.params.reservaId,
        reserva.detalles.horarioId,
        reserva.detalles.localId
      )
    );
  }

  if (loading) {
    return (
      <Content title="Reserva" browserTitle="Agendia" show={false}>
        <Col md="12">
          <LoaderCalendario loading={true} />
        </Col>
      </Content>
    );
  }
  return (
    <Content title="Reserva" browserTitle="Agendia" show={false}>
      <Col md="12">
        <Box
          title={"Detalles de reserva"}
          customOptions={
            <Button
              type="primary"
              text="Atras"
              onClick={() => history.goBack()}
            />
          }
        >
          <Col md="12">
            Estado: {reserva?.estado}
            <br />
            <br />
            {reserva?.detalles?.nombre && (
              <>
                Reservado por: {reserva.detalles.nombre}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.email && (
              <>
                Email: {reserva.detalles.email}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.nombrePaciente && (
              <>
                Nombre del paciente: {reserva.detalles.nombrePaciente}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.nombre_paciente && (
              <>
                Nombre del paciente: {reserva.detalles.nombre_paciente}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.ci && (
              <>
                CI: {reserva.detalles.ci}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.telefono && (
              <>
                Telefono: {reserva.detalles.telefono}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.seguroId && reserva.detalles.seguroNombre && (
              <>
                Seguro: {reserva.detalles.seguroNombre}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.profesionalNombre && (
              <>
                Profesional: {reserva?.detalles?.profesionalNombre}
                <br />
                <br />
              </>
            )}
            Servicio: {reserva?.detalles?.servicioNombre}
            <br />
            <br />
            {reserva?.detalles?.ambienteNombre && (
              <>
                Ambiente: {reserva?.detalles?.ambienteNombre} válido para{" "}
                {reserva?.detalles?.validoPara} personas
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.nroMesa && (
              <>
                Mesa nro: {reserva.detalles.nroMesa}
                <br />
                <br />
              </>
            )}
            {!reserva?.detalles?.profesionalNombre ? (
              <>
                Fecha: {fecha}
                <br />
                <br />
              </>
            ) : (
              <>
                Desde: {desde}
                <br />
                <br />
                Hasta: {hasta}
                <br />
                <br />
              </>
            )}
            {reserva?.detalles?.comentario && (
              <>
                Comentario: {reserva.detalles.comentario}
                <br />
                <br />
              </>
            )}
            {actualRol === "superadmin" || actualRol === "admin" ? (
              <Button
                pullRight={true}
                type="primary"
                text="Eliminar reserva"
                disabled={loading || reserva?.estado === "CANCELADO"}
                onClick={cancelarReserva}
              />
            ) : null}
          </Col>
        </Box>
      </Col>

      <Col md="12">
        <Box title="Reservas en mismo horario, servicio y profesional">
          <div>
            <span>Total: {totalResults}</span>
          </div>
          {list && list.length > 0 ? (
            <SimpleTable
              hover={true}
              data={list.map((row, index) => {
                return {
                  nombre: row.detalles.nombre,
                  telefono: row.detalles.telefono || "N/A",
                  ci: row.detalles.ci || "N/A",
                  estado: row.estado,
                  detalles: (
                    <Button
                      type="primary"
                      text="Detalles"
                      onClick={() => {
                        history.push(`/reserva/${row._id}`);
                        window.location.reload();
                      }}
                    />
                  ),
                };
              })}
              columns={[
                { title: "Nombre", data: "nombre" },
                { title: "Telefono", data: "telefono" },
                { title: "Documento", data: "ci" },
                { title: "Estado", data: "estado" },
                { title: "Detalles", data: "detalles" },
              ]}
            />
          ) : (
            <h4>No se han encontrado reservas en el mismo horario</h4>
          )}
          <Pagination
            activePage={activePage}
            pageSize={pageSize}
            totalElements={totalResults}
            onChange={handlePage}
            labels={{
              first: "Primera",
              last: "Última",
              previous: "Anterior",
              next: "Siguiente",
            }}
          />
          <div>
            <span>Total: {totalResults}</span>
          </div>
        </Box>
      </Col>
    </Content>
  );
}

export default ReservaDetalle;
